import _slicedToArray from "/usr/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import React from "react";
var __jsx = React.createElement;
import { useTranslation } from "@i18n";
import stl from "./UnbxdTextSearch.module.css";
import { useLocation, useSearchParams } from "react-router-dom";
import { useEffect, useRef, useState } from "react";
import Suggestions from "./Suggestions/Suggestions";
import useUnbxdTextSearch from "../../../../../../common/hooks/useUnbxdTextSearch";
import { CDN_LINK } from "@globalConfig";
import useHelpers from "@hooks/useHelpers";
import { useAuthActions } from "@/_MiniApps/auth/AuthContext";
import useLocalStorage from "@hooks/useLocalStorage";
var UnbxdTextSearch = function UnbxdTextSearch(_ref) {
  var setPage = _ref.setPage,
    customClass = _ref.customClass,
    _ref$referral_locatio = _ref.referral_location,
    referral_location = _ref$referral_locatio === void 0 ? null : _ref$referral_locatio;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useLocalStorage = useLocalStorage(false),
    setLocalStorage = _useLocalStorage.setLocalStorage;
  var existingSearches = [];
  var _useState = useState(false),
    isFocused = _useState[0],
    setIsFocused = _useState[1];
  var inputRef = useRef();
  var _useSearchParams = useSearchParams(),
    _useSearchParams2 = _slicedToArray(_useSearchParams, 1),
    searchParams = _useSearchParams2[0];
  var searchTermParam = searchParams.get("text");
  var _useHelpers = useHelpers(),
    navigateTo = _useHelpers.navigateTo,
    createUrl = _useHelpers.createUrl;
  var location = useLocation();
  var _useUnbxdTextSearch = useUnbxdTextSearch(setPage),
    searchTerm = _useUnbxdTextSearch.searchTerm,
    searchTermSuggestions = _useUnbxdTextSearch.searchTermSuggestions,
    handleSearchTermChange = _useUnbxdTextSearch.handleSearchTermChange,
    _handleTextSearch = _useUnbxdTextSearch.handleTextSearch,
    setSearchTerm = _useUnbxdTextSearch.setSearchTerm,
    setSearchTermSuggestions = _useUnbxdTextSearch.setSearchTermSuggestions;
  var _useAuthActions = useAuthActions(),
    getSearchHistoryFromLocalStorage = _useAuthActions.getSearchHistoryFromLocalStorage,
    syncSearchHistoryOnLogin = _useAuthActions.syncSearchHistoryOnLogin; // Access the function

  useEffect(function () {
    if (!searchTermParam) {
      setSearchTerm("");
      return;
    }
    setSearchTerm(searchTermParam);
  }, [location.search]);
  useEffect(function () {
    isFocused && setLocalStorage('text_search_referral_location', referral_location);
  }, [isFocused]);
  return /*#__PURE__*/React.createElement("form", {
    className: [stl.wrapper, customClass !== null && customClass !== void 0 ? customClass : undefined].join(" "),
    id: "unbxd-text-search_bar-container"
  }, /*#__PURE__*/React.createElement("input", {
    type: "text",
    placeholder: t("ابحث عن الماركة او الموديل", {
      ns: "web_search"
    }),
    onChange: handleSearchTermChange,
    value: searchTerm,
    onFocus: function onFocus() {
      setIsFocused(true);
      syncSearchHistoryOnLogin();
    },
    onBlur: function onBlur() {
      return setTimeout(function () {
        return setIsFocused(false);
      }, 200);
    },
    ref: inputRef,
    onKeyDown: function onKeyDown(e) {
      if (e.key === "Enter") {
        inputRef.current.blur();
        setSearchTermSuggestions([]);
        _handleTextSearch(e);
      }
    },
    className: "interActiveGray"
  }), searchTermParam && searchTerm ? /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/clear.svg",
    alt: "",
    className: "hasEvents",
    onClick: function onClick(e) {
      e.stopPropagation();
      setSearchTerm("");
      setSearchTermSuggestions([]);
      navigateTo("/filters");
    }
  }) : /*#__PURE__*/React.createElement("img", {
    onClick: function onClick(e) {
      e.preventDefault();
      _handleTextSearch(e);
    },
    src: CDN_LINK + "/assets/images/text-search-icon.svg",
    width: 15,
    height: 15,
    alt: "search",
    className: "hasEvents cursor-pointer"
  }), isFocused && /*#__PURE__*/React.createElement("div", {
    className: "border border-[#f5f7fa] bg-white left-0 right-0 top-[102%] rounded max-h-[476px] absolute overflow-y-auto shadow-[0_0_10px_rgba(188,188,188,0.4)] scrollbar-thin scrollbar-thumb-gray-400 scrollbar-track-gray-100 z-[9]",
    style: {
      scrollbarWidth: "thin"
    }
  }, searchTermSuggestions.length ? /*#__PURE__*/React.createElement(Suggestions, {
    searchTerm: searchTerm,
    suggestionsData: searchTermSuggestions
    // handleTextSearch={handleTextSearch}
    ,
    handleTextSearch: function handleTextSearch(e, sug) {
      _handleTextSearch(e, sug);
    }
  }) : null, getSearchHistoryFromLocalStorage().length > 0 && /*#__PURE__*/React.createElement("div", {
    className: "p-[24px] px-4 py-6"
  }, /*#__PURE__*/React.createElement("strong", {
    className: "text-[#484848] text-sm font-bold leading-[24px] block"
  }, t("البحوث الأخيرة", {
    ns: "web_search"
  })), /*#__PURE__*/React.createElement("ul", null, getSearchHistoryFromLocalStorage().map(function (item, index) {
    return index < 5 && /*#__PURE__*/React.createElement("li", {
      key: index,
      className: "flex items-center gap-1 mt-3"
    }, /*#__PURE__*/React.createElement("img", {
      src: CDN_LINK + "/assets/images/searchHistoryIcon.svg",
      width: "24px",
      height: "24px",
      alt: "search history"
    }), /*#__PURE__*/React.createElement("a", {
      className: "rounded-[32px] border border-[#E1E8F2] bg-[#F1F6FC] flex p-2 justify-center items-center text-[#0E5BC0] text-xs font-semibold leading-[16px]",
      href: createUrl("/filters?text=" + item.text + "&fromRecentSearch=1")
    }, item.text));
  })))));
};
export default UnbxdTextSearch;